export default {

	"1": {

		"897": "Halloween 2019"

	},

	"4": {

		"896": "Halloween 2019"

	},

	"7": {

		"895": "Halloween 2019"

	},

	"19": {

		"45": "Normal",

		"46": "Alolan"

	},

	"20": {

		"47": "Normal",

		"48": "Alolan"

	},

	"26": {

		"49": "Normal",

		"50": "Alolan"

	},

	"27": {

		"51": "Normal",

		"52": "Alolan"

	},

	"28": {

		"53": "Normal",

		"54": "Alolan"

	},

	"37": {

		"55": "Normal",

		"56": "Alolan"

	},

	"38": {

		"57": "Normal",

		"58": "Alolan"

	},

	"50": {

		"59": "Normal",

		"60": "Alolan"

	},

	"51": {

		"61": "Normal",

		"62": "Alolan"

	},

	"52": {

		"63": "Normal",

		"64": "Alolan"

	},

	"53": {

		"65": "Normal",

		"66": "Alolan"

	},

	"74": {

		"67": "Normal",

		"68": "Alolan"

	},

	"75": {

		"69": "Normal",

		"70": "Alolan"

	},

	"76": {

		"71": "Normal",

		"72": "Alolan"

	},

	"88": {

		"73": "Normal",

		"74": "Alolan"

	},

	"89": {

		"75": "Normal",

		"76": "Alolan"

	},

	"103": {

		"77": "Normal",

		"78": "Alolan"

	},

	"105": {

		"79": "Normal",

		"80": "Alolan"

	},

	"150": {

		"133": "Armored",

		"135": "Normal"

	},

	"201": {

		"1": "A",

		"2": "B",

		"3": "C",

		"4": "D",

		"5": "E",

		"6": "F",

		"7": "G",

		"8": "H",

		"9": "I",

		"10": "J",

		"11": "K",

		"12": "L",

		"13": "M",

		"14": "N",

		"15": "O",

		"16": "P",

		"17": "Q",

		"18": "R",

		"19": "S",

		"20": "T",

		"21": "U",

		"22": "V",

		"23": "W",

		"24": "X",

		"25": "Y",

		"26": "Z",

		"27": "!",

		"28": "?"

	},

	"327": {

		"37": "",

		"38": "1",

		"39": "2",

		"40": "3",

		"41": "4",

		"42": "5",

		"43": "6",

		"44": "7",

		"121": "8",

		"122": "9",

		"123": "10",

		"124": "11",

		"125": "12",

		"126": "13",

		"127": "14",

		"128": "15",

		"129": "16",

		"130": "17",

		"131": "18",

		"132": "19"

	},

	"351": {

		"29": "Normal",

		"30": "Sunny",

		"31": "Rainy",

		"32": "Snowy"

	},

	"386": {

		"33": "Normal",

		"34": "Attack",

		"35": "Defense",

		"36": "Speed"

	},

	"412": {

		"118": "Plant",

		"119": "Sandy",

		"120": "Trash"

	},

	"413": {

		"87": "Plant",

		"88": "Sandy",

		"89": "Trash"

	},

	"421": {

		"94": "Overcast",

		"95": "Sunny"

	},

	"422": {

		"96": "West Sea",

		"97": "East Sea"

	},

	"423": {

		"98": "West Sea",

		"99": "East Sea"

	},

	"479": {

		"81": "Normal",

		"82": "Frost",

		"83": "Fan",

		"84": "Mow",

		"85": "Wash",

		"86": "Heat"

	},

	"487": {

		"90": "Altered",

		"91": "Origin"

	},

	"492": {

		"92": "Sky",

		"93": "Land"

	},

	"493": {

		"100": "Normal",

		"101": "Fighting",

		"102": "Flying",

		"103": "Poison",

		"104": "Ground",

		"105": "Rock",

		"106": "Bug",

		"107": "Ghost",

		"108": "Steel",

		"109": "Fire",

		"110": "Water",

		"111": "Grass",

		"112": "Electric",

		"113": "Psychic",

		"114": "Ice",

		"115": "Dragon",

		"116": "Dark",

		"117": "Fairy"

	}

};